import ScootersLockHistoryPage from './ScootersLockHistoryPage';
export default ScootersLockHistoryPage;
